<script setup lang="ts">
const {
  searchKeyword,
  isLoading,
  legalAreaFacetOptions,
  legalAreaSelected,
  toggleLegalArea,
  searchLegalArea,
  authorFacetOptions,
  authorSelected,
  toggleAuthor,
  searchAuthor,
} = useTemplateFilters()
</script>

<template>
  <aside aria-label="Filtervalg" class="flex flex-col gap-m w-[369px] pt-l">
    <div class="flex flex-col gap-s">
      <span aria-hidden="true" class="title-s font-bold">
        Filtrer på tittel eller forfatter
      </span>
      <FormSearchInput
        id="template-title-author-filter"
        v-model="searchKeyword"
        resettable
        shape="square"
        size="medium"
        label="Filtrer på tittel eller forfatter"
      />
    </div>

    <FilterSkeleton v-if="isLoading" />

    <template v-else>
      <div v-if="legalAreaFacetOptions.length" class="flex flex-col gap-s">
        <span class="text-small font-bold">Rettsområde</span>
        <FilterFacetList
          v-model:search="searchLegalArea"
          class="gap-s"
          label="Rettsområde"
          name="templateLegalArea"
          expand-noun="rettsområder"
          :options="legalAreaFacetOptions"
          :selected="legalAreaSelected"
          :toggle="toggleLegalArea"
        />
      </div>

      <div v-if="authorFacetOptions.length" class="flex flex-col gap-s">
        <span class="text-small font-bold">Forfattere</span>
        <FilterFacetList
          v-model:search="searchAuthor"
          class="gap-s"
          label="Forfattere"
          name="templateAuthor"
          expand-noun="forfattere"
          :options="authorFacetOptions"
          :selected="authorSelected"
          :toggle="toggleAuthor"
        />
      </div>
    </template>
  </aside>
</template>